export default {
  SET_states(state, payload) {
    state.states = payload
  },
  SET_employeesDepartments(state, payload) {
    state.employeesDepartments = payload
  },
  SET_employeesFunctions(state, payload) {
    state.employeesFunctions = payload
  },
  SET_employeesRoles(state, payload) {
    state.employeesRoles = payload
  },
  SET_maritalStatus(state, payload) {
    state.maritalStatus = payload
  },
  SET_genders(state, payload) {
    state.genders = payload
  },
  SET_monthsOfTheYear(state, payload) {
    state.monthsOfTheYear = payload
  },
  SET_employeePaycheck(state, payload) {
    state.employeePaycheck = payload
  },
  SET_authorizations(state, payload) {
    state.authorizations = payload
  },
  SET_permissions(state, payload) {
    state.permissions = payload
  },
  SET_status(state, payload) {
    //refatorar remover todos setters
    state.status = payload
  },
  SET_utils(state, payload) {
    Object.keys(state).map((key) => {
      state[key] = payload[key]
    })
  },
}
